import instance from "@/services/api";
import { buildingSettingsAPI } from "@/views/BuildingSettings/services/api";

export const workSetCheckGroupSchemaAPI = {
  async getProjectTypes() {
    const res = await buildingSettingsAPI.getProjectTypes();
    const data = Array.isArray(res) ? res : res?.data ?? [];
    return { data };
  },
  async getWorkSetCheckGroups() {
    const res = await instance().get("/common/work_set_check_groups/for_sbs/read/");
    const data = res?.data?.data ?? res?.data ?? [];
    return { data };
  },
  async getWorkSetCheckGroupsByProjectType(projectTypeId) {
    if (projectTypeId == null) return { data: [] };
    const res = await instance().get(
      "/common/work_set_check_groups/by_project_type/read/",
      { params: { project_type_id: projectTypeId } }
    );
    const data = res?.data?.data ?? res?.data ?? [];
    return { data };
  },
  async getBpmnSchemas() {
    const res = await instance().get(
      "/handbook/work_set_check_group_schema/schema/read/"
    );
    const data = res?.data?.data ?? res?.data ?? [];
    return { data };
  },
  async getRows(params = {}) {
    const safeParams = {};
    if (params.project_type_id != null) {
      safeParams.project_type_id = params.project_type_id;
    }
    if (params.work_set_check_group_id != null) {
      safeParams.work_set_check_group_id = params.work_set_check_group_id;
    }
    if (params.schema_id != null) {
      safeParams.schema_id = params.schema_id;
    }
    const res = await instance().get(
      "/handbook/work_set_check_group_schema/read/",
      { params: safeParams }
    );
    const data = res?.data?.data ?? res?.data ?? [];
    return { data };
  },
  async modify(body) {
    const res = await instance().post(
      "/handbook/work_set_check_group_schema/modify/",
      body
    );
    const data = res?.data?.data ?? res?.data;
    return { data };
  },
  async deleteRow(workSetCheckGroupSchemaId) {
    if (!workSetCheckGroupSchemaId) return;
    const res = await instance().delete(
      `/handbook/work_set_check_group_schema/${workSetCheckGroupSchemaId}/delete/`
    );
    const data = res?.data?.data ?? res?.data;
    return { data };
  },
};
